import { createApiService } from './createApiService'

export enum PromptType {
  PROMPT_SYSTEM = 'PROMPT_SYSTEM',
  PROMPT_INSPIRATION = 'PROMPT_INSPIRATION'
}

export interface Prompt {
  id: number;
  name: string;
  note: string | null;
  content: string;
  promptType: PromptType;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export const promptsAPI = createApiService({
  reducerPath: 'promptsAPI',
  tagTypes: ['Prompts'],
  endpoints: (build: any) => ({
    getActivePrompts: build.query({
      query: () => '/prompts',
      providesTags: ['Prompts'],
    }),
    getAllPrompts: build.query({
      query: () => '/admin/prompts',
      providesTags: ['Prompts'],
    }),
    getPrompt: build.query({
      query: (id: number) => `/admin/prompts/${id}`,
      providesTags: (result: any, error: any, id: number) => [{ type: 'Prompts', id }],
    }),
    createPrompt: build.mutation({
      query: (prompt: Partial<Prompt>) => ({
        url: '/admin/prompts',
        method: 'POST',
        body: prompt,
      }),
      invalidatesTags: ['Prompts'],
    }),
    updatePrompt: build.mutation({
      query: ({ id, prompt }: { id: number; prompt: Partial<Prompt> }) => ({
        url: `/admin/prompts/${id}`,
        method: 'PUT',
        body: prompt,
      }),
      invalidatesTags: ['Prompts'],
    }),
    deletePrompt: build.mutation({
      query: (id: number) => ({
        url: `/admin/prompts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Prompts'],
    }),
  }),
})

export const {
  useGetActivePromptsQuery,
  useGetAllPromptsQuery,
  useGetPromptQuery,
  useCreatePromptMutation,
  useUpdatePromptMutation,
  useDeletePromptMutation,
} = promptsAPI